import React from 'react'
import './Info.css'

const Info = () => {
  return (
    <div className='info'>
        <div className="hl-0"></div>
        <div className="hl-1"></div>
        <div className="hl-2"></div>
        <div className="hl-3"></div>
        <div className="info-wrapper">
            <div className="left-content"><span style={{'zIndex': '1'}}>20</span>
            <span className='right-content' id='years' style={{'zIndex': '1'}}>
                <span style={{'color': '#c5a47e'}}>Years of successful work</span><br /> in the market
            </span>
            </div>
        </div>
    </div>
  )
}

export default Info
